import { COUNTERTOP_MOK_KEY_PREFIX, COUNTERTOP_NONE_KEY } from '../../countertop-material/constants';
import islandAssetMap from '../../data/island-asset.map.json';
import { IslandAssetData, IslandAssetProperties } from '../../islands/types';
import { IslandType } from '../../public.enums';
import { Countertop } from '../countertop.class';

/**
 * Calculates countertop sku based on island width and surround material
 * @Param countertop Countertop
 * @returns Sku
 */
export const getCountertopSkuCfn = (countertop: Countertop): string => {
	const materialKey = countertop.material.key;
	if (materialKey === COUNTERTOP_NONE_KEY || materialKey.startsWith(COUNTERTOP_MOK_KEY_PREFIX)) return '';

	const island = countertop.refMap.kitchenDesign.islands.findById(countertop.islandIds[0]);
	if (!island) return 'RTA-Granite-xFT-xxxx';


	const assetMap: Record<string, IslandAssetData> = islandAssetMap;
	const width = island.getOverhangs().left >= 6 || island.getOverhangs().right >= 6 ? countertop.size.width : island.size.width;
	let key: string = null;
	let assetData: IslandAssetProperties = null;


	for (const size in assetMap.STANDARD) {
		if (size) {
			key = size;
			assetData = assetMap.STANDARD[size];
			if (width > assetData.min && width <= assetData.max) break;
		}
	}

	const islandLength = island.isCornerIsland
		? '5'
		: island.type === IslandType.Asado || island.type === IslandType.Pizza
			? '3'
			: key
	const countertopCode = countertop.material.code;
	const cornerCode = island.isCornerIsland ? 'C' : '';
	const material = countertop.material.isGranite
		? 'Granite'
		: (
			countertop.material.edge === 'clean' ? 'CE' : 'Chiselededge'
		)
	const sku = `RTA-${material}-${islandLength}FT${cornerCode}-${countertopCode.toUpperCase()}`;

	return sku;
};
